import { TaskNote } from "../../../redux/myTasks";
import { REMINDER_PARENT_HREF_BUILDERS } from "../../../utils/reminderParentHref";

/** Resolves a task's click-through destination from its parent record; undefined if unmapped. */
export function getTaskHref(note: TaskNote): string | undefined {
  // Projects use the SPA route, matching the rest of the new nav bar.
  if (note.parent_type === "JOB") {
    return note.job_number ? `/project/${note.job_number}` : undefined;
  }
  const buildHref = REMINDER_PARENT_HREF_BUILDERS[note.parent_type];
  return buildHref && note.parent_id ? `/${buildHref(note.parent_id)}` : undefined;
}
